/* eslint-disable react-refresh/only-export-components -- vendored shadcn/ui component */
import { cva, type VariantProps } from 'class-variance-authority';
import { Toggle as TogglePrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '@/_shared/lib/utils';

const toggleVariants = cva(
  'inline-flex cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        // Hover falls through to the base `hover:bg-muted` (grey) — accent is reserved
        // for the selected `data-[state=on]` state, not hover.
        outline: 'border border-input bg-transparent shadow-xs',
      },
      // Heights track Button / Input / Select (sm h-6 · md h-7 · lg h-8). `min-w`
      // keeps icon-only items squareish; the roomier `px` gives text items breathing space.
      size: {
        sm: 'h-6 min-w-6 gap-1.5 rounded-sm px-2 text-[0.8125rem]',
        md: 'h-7 min-w-7 px-2.5',
        lg: 'h-8 min-w-8 px-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
);

function Toggle({
  className,
  variant,
  size,
  ref,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
  return <TogglePrimitive.Root ref={ref} className={cn(toggleVariants({ variant, size, className }))} {...props} />;
}

export { Toggle, toggleVariants };
